export default "__VITE_ASSET__70a8d12e__"